module.exports = __webpack_public_path__ + "static/media/1024.fa297cef.png";